jQuery(document).ready(function($) {
    //    var card_total = "";
    //    var loadmore = "";
    //    var visible_cards = "";
    
       jQuery('.loadmore_button').on('click', function() {
            console.log( "Loadmore Clicked 3 ..." );
            // Get the parent .postgrid of the clicked loadmore_button
            var load_number = 6;
            var fade_duration = 300;
            
            var postgrid = jQuery(this).closest('.postgrid');
            
            // Count total cards with class .card-con inside .postgrid
            var card_total = postgrid.find('.card-con').length;
            
            // Count loadmore buttons inside .postgrid
            var loadmore = postgrid.find('.loadmore').length;
            
            // Calculate visible cards
            var visible_cards = card_total - loadmore;
            
            // Output or use the visible_cards value as needed
            console.log("Total cards:", card_total);
            console.log("Loadmore buttons:", loadmore);
            console.log("Visible cards:", visible_cards);
    
            var loadmore_elements = postgrid.find('.loadmore').slice(0, load_number);
    
            loadmore_elements.each(function(index) {
                var element = jQuery(this);
                // Delay each element's fade in effect by 0.3 seconds multiplied by its index
                setTimeout(function() {
                    element.css({
                        'display': 'flex',
                        'opacity': 0
                    }).fadeTo(fade_duration, 1).removeClass('loadmore');
                }, index * 150);
            });
    
            if (visible_cards + load_number >= card_total){
                jQuery(this).fadeOut();
            }
    
            // Optionally, you can perform further actions based on visible_cards
        });
    });